import { useEffect } from "react";
import FilterValueProps from "types/FilterValueProps";

interface useParentFilterProps{
    parentFilterParentParams?: any
    parentFilterParams: FilterValueProps[]
    setParentFilterParams: Function
    setParentValue: Function
    setOptions: Function
    parentFilterParam: string | false
    parentValue: string | false
    allOptions: FilterValueProps[]
    setLabelText: Function
    setDefaultOption: Function
    setFilterParam: Function
    param: string
    wasLoaded: boolean
    setWasLoaded: Function
    unselectAll: Function
    isLoaded?: Function
}


const useParentFilter = (props: useParentFilterProps) => {


    const filterOptions = (parentValue: string | Array<string>, options: any) => {
      const filteredOptions = options.filter(option => {
        return Array.isArray(parentValue) ? parentValue.includes(option.parent_value) : option.parent_value === parentValue;
      })

      return filteredOptions
    }

    const getFilteredOptions = (parentFilter: string | false, parentFilterParams: any, allOptions: FilterValueProps[]) => {
        let filteredOptions = []
    
        if (parentFilter && parentFilterParams && (typeof parentFilterParams[parentFilter] !== 'undefined')) {
          filteredOptions = filterOptions(parentFilterParams[parentFilter], allOptions)
        }
    
        return filteredOptions
      }
    
    

    useEffect(() => {
        if ((typeof props.parentFilterParentParams !== 'undefined')) {
          let newParentFilterParams = {}
          for (const param of Object.keys(props.parentFilterParentParams)) {
            const value = props.parentFilterParentParams[param]
            newParentFilterParams = ({...newParentFilterParams, [param]: value})
          }
    
          props.setParentFilterParams(newParentFilterParams)
        }
      }, [props.parentFilterParentParams])
    
      useEffect(() => {
        if (props.parentFilterParam) {
          if((props.parentFilterParams[props.parentFilterParam] !== props.parentValue)){
            const filteredOptions = getFilteredOptions(props.parentFilterParam, props.parentFilterParams, props.allOptions)
            props.setParentValue(props.parentFilterParams[props.parentFilterParam])
            props.unselectAll()
            props.setOptions([...filteredOptions])
            
            if (!props.wasLoaded) {
              props.setWasLoaded(true)
              props.isLoaded && props.isLoaded(props.param)
            }
          }
        }
    
      }, [props.parentFilterParams, props.parentFilterParam, props.allOptions])
    

}


export default useParentFilter 